<script setup lang="ts">
const { data: ui } = useGamePresentationUI()
</script>

<template>
  <div class="flex h-full items-center justify-center px-6 py-10">
    <div class="w-full max-w-lg">
      <UCard :ui="{ body: 'bg-muted/5 text-center' }">
        <div class="flex flex-col items-center gap-5 py-4">
          <UIcon
            class="size-12 text-primary"
            name="mdi:cast-connected"
          />
          <h1 class="text-balance text-2xl font-black tracking-tight sm:text-3xl">
            {{ ui?.presenterPairingTitle }}
          </h1>
          <p class="max-w-md text-balance text-sm text-muted sm:text-base">
            {{ ui?.presenterPairingDescription }}
          </p>
          <div class="w-full pt-2">
            <GamePresentationPresenterPairingForm/>
          </div>
        </div>
      </UCard>
    </div>
  </div>
</template>
